import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { BodyTextMedium, HeadlineTextSmall } from 'Packages/FacetDesign/Components';
import CapitalizeInfoRow from 'Views/Page/Content/Modal/Layouts/ConciergeTransactionTemplate/CapitalizeInfoRow';
import ScheduledMeetingDetails
  from 'Packages/FacetDesign/Components/Experimental/ScheduledMeetingDetails/ScheduledMeetingDetails';
import fr from 'facet-rest';
import { navigateToUriInNewTab } from 'Helpers/Navigation';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('ConciergeTransactionTemplate', () => ({
  bottomBorder: {
    borderBottom: '1px solid #CCC',
  },
}));

const ConciergeTransactionTemplate = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();

  const handleRescheduleMeeting = async (e) => {
    navigateToUriInNewTab(e, resource.relationship(fr.relationships.rescheduleMeeting.name).link('related').url());
  };

  return (
    <FDStack direction={'column'} spacing={4} padding={4} {...dataAttrs('concierge-transaction')}>
      <MetaControlField attr={'title'} />
      {resource.isTruthy('hasMeeting')
        ? <ScheduledMeetingDetails
          meetingName={resource.attr('meetingName')}
          meetingStartTime={resource.attr('meetingStartTime')}
          meetingEndTime={resource.attr('meetingEndTime')}
          meetingDuration={resource.attr('meetingDuration')}
          agentProfileImageLink={resource.relationship(fr.relationships.agentProfileImage.name)}
          rescheduleLink={resource.relationship(fr.relationships.rescheduleMeeting.name)}
          onReschedule={resource.relationship(fr.relationships.rescheduleMeeting.name) ? handleRescheduleMeeting : null}
        /> : null}
      <MetaControlField attr={'header'} />

      <FDStack direction={'column'} spacing={2}>
        <CapitalizeInfoRow attrName={'status'} />
        <CapitalizeInfoRow attrName={'from'} />
        <CapitalizeInfoRow attrName={'to'} />
        <CapitalizeInfoRow attrName={'lastUpdated'} />
      </FDStack>

      <FDStack direction={'column'} spacing={1}>
        <MetaControlField attr={'nextStepsTitle'} />
        <FDStack direction="column" spacing={0}>
          <MetaControlField attr={'nextSteps'} />
          <FDStack paddingX={1}>
            <MetaControlField attr={'nextStepsBullets'} />
          </FDStack>
        </FDStack>
        {resource.attr('nextSteps') || resource.attr('nextStepsTitle') || resource.attr('nextStepsBullets') ? <div className={classes.bottomBorder} /> : null}
      </FDStack>

      <FDStack direction={'column'}>
        <HeadlineTextSmall value={'Question?'} />
        <BodyTextMedium value={'For common questions or to reach out to our support team:'} />
        <a href={`mailto:${resource.attr('supportTeamEmail')}`}>
          {resource.attr('supportTeamEmail')}
        </a>
      </FDStack>
    </FDStack>
  );
};

export default ConciergeTransactionTemplate;
